export const DEFAULT_COMPANY = "helix_cloud_gmbh";
export const COMPANY_HEADER = "x-strategyiq-company";
